<template>
    <form-dialog ref="form-saveas" title="另存为模板" :data="data" width="80%" :visible.sync="visibleSync" :columns="columnList" @confirm="SaveAs"></form-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnesthesiaChargeTemplateSaveAs`,
    props: {
        visible: { type: Boolean, default: () => false },
        data: { type: Object }
    },
    data() {
        return {
            title: `麻醉计费模板另存为`,
            item_configs: []
        }
    },
    created() {},
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `sys_enums`]),
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_charge_type`,
                    label: `类型`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    options: this.sys_enums.ChargeType || [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    colspan: 6,
                    options: `enum_region_type`,
                    default: 1
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    // width: "180",
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    colspan: 6,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `table`,
                    prop: `items`,
                    label: `项目`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `number`,
                            prop: `display_order`,
                            label: `排序`,
                            isListable: true,
                            readonly: false,
                            default: 1
                        },
                        {
                            type: `remoteselect`,
                            prop: `dic_chrg_item`,
                            label: `名称`,
                            width: `400`,
                            isListable: true,
                            readonly: false,
                            options: (that, { row }) => {
                                return q => {
                                    return this.loadChargeItemList(q)
                                }
                            }
                        },
                        {
                            type: `number`,
                            prop: `amount`,
                            label: `数量`,
                            isListable: true,
                            readonly: false,
                            default: 1
                        }
                    ],
                    colspan: 24,
                    default: []
                }
            ]
        }
    },
    methods: {
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`api/AcisSystem/ChargeTemplate/Post`, {
                    name: row.name,
                    enum_charge_type: row.enum_charge_type,
                    items: _.reduce(
                        _.groupBy(row.items, `dic_chrg_item.value`),
                        function(result, value, key) {
                            let sOne =
                                _.find(value, d => {
                                    return d.id > 0
                                }) || value[0]
                            let r = {
                                dic_chrg_item_id: key,
                                amount: _.sumBy(value, `amount`),
                                display_order: sOne.display_order
                            }
                            result.push(r)
                            return result
                        },
                        []
                    ),
                    regions:
                        row.region_type == 1
                            ? [{ owner: this.currentUser.username }]
                            : row.dic_ward_ids.map(d => {
                                return {
                                    // "sys_charge_template_id": 0,
                                    dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                                    dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                                }
                            })
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        SaveAs(row) {
            this.saveOne(row).then(data => {
                this.$emit(`save-success`)
                this.visibleSync = false
            })
        },
        loadChargeItemList(q) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/ChargeItem/Search?keyword=${q && q.keyword}`)
                let req1 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=ChargeItemCodeConfig`)
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    this.item_configs = data1.value.split(`|`)
                    data = _.map(data, d => {
                        let codes = []
                        for (let item of this.item_configs) {
                            if (item === `0`) codes.push(d.code)
                            if (item === `1`) codes.push(d.spec || `--`)
                            if (item === `2`) codes.push(d.price || `--`)
                            if (item === `3`) codes.push(d.sell_unit || `--`)
                            if (item === `4`) codes.push(d.firm || `--`)

                            if (item === `5`) codes.push(d.uni_charge_code || `--`)
                            if (item === `6`) codes.push(d.medical_type || `--`)
                            if (item === `7`) codes.push(`库存:${d.inventory || `--`}`)
                            if (item === `8`) codes.push(d.description || `--`)
                        }
                        return {
                            value: d.id,
                            label: d.name,
                            abbr: d.abbr,
                            code: codes.join(`/`)
                        }
                    })
                    resolve(data)
                })
            })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Charge/Anesthesia/SaveAs.vue